import jwt from 'jwt-decode';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { TokenSchema } from '../utils/TokenSchema';
import empresasService from '../../../services/empresas';

const ESTADOS = {
  ERROR_INICIAL: 'ERROR_INICIAL',
  LOADING: 'LOADING',
  PRE_CONFIRMACION: 'PRE_CONFIRMACION',
  CONFIRMACION: 'CONFIRMACION',
  SOLICITUD_RECHAZADA: 'SOLICITUD_RECHAZADA',
  SOLICITUD_APROBADA: 'SOLICITUD_APROBADA'
};

export const useConecederAdministracion = () => {
  const [vista, setVista] = useState(ESTADOS.LOADING);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [terminosAceptados, setTerminosAceptados] = useState(false);
  const [data, setData] = useState();
  const [token, setToken] = useState();

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const onConfirmarSolicitud = async accion => {
    try {
      setIsSubmiting(true);
      const response = await empresasService.confirmarAdministracion({
        token: token,
        accion: accion
      });
      if (response.status === 200 && response.data === true) {
        if (accion === 'aceptar') {
          setVista(ESTADOS.SOLICITUD_APROBADA);
        } else if (accion === 'rechazar') {
          setVista(ESTADOS.SOLICITUD_RECHAZADA);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmiting(false);
    }
  };

  const onVerificacionInicial = async () => {
    try {
      const token = params.get('token');
      const data = await verificarToken(token);
      setData(data);
      setVista(ESTADOS.PRE_CONFIRMACION);
    } catch (error) {
      setVista(ESTADOS.ERROR_INICIAL);
    }
  };

  const verificarToken = async token => {
    if (!token) return null;
    const objetoDecifrado = jwt(token);
    const response = await TokenSchema.validate(objetoDecifrado, {
      abortEarly: false
    });
    setToken(token);
    return response;
  };

  useEffect(() => {
    onVerificacionInicial();
  }, []);

  return {
    ESTADOS,

    data,
    vista,
    isSubmiting,
    terminosAceptados,

    setTerminosAceptados,
    setVista,

    onConfirmarSolicitud
  };
};
